export const getWebshopColors = async () => {
  try {
    const response = await fetch(`/Widget/webshopcolors`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await response.json();
  } catch (error) {
    throw new Error(`request failed, HTTP status ${error}`);
  }
};
